/**
 * Helpers for layout diagnostics around the SRP payload.
 *
 * We intentionally do **not** merge `useData()` into `pageContext.data` in the root layout:
 * during client navigations between two SRP URLs, `useData()` can still hold the previous
 * page's index payload while `pageContext.data` is briefly empty, which would re-apply stale
 * `initialFilters` and overwrite URL-aligned search state in SearchProvider.
 */

export function layoutPageDataLacksSrpPayload(data: unknown): boolean {
  if (data == null || typeof data !== 'object') return true;
  const d = data as Record<string, unknown>;
  if (typeof d.indexName === 'string' && d.indexName.length > 0) return false;
  if (d.srpViewModel != null) return false;
  if (d.initialResults != null) return false;
  return true;
}
